// extracted by mini-css-extract-plugin
export default {"container":"MpYs","title":"S1TV","description":"VHrX"};